export default function SkillsLearned() {
  const skills = [
    { icon: 'ri-file-list-3-line', title: 'Подготовка к переговорам', desc: 'Сбор информации, анализ интересов, определение целей и запасных вариантов' },
    { icon: 'ri-arrow-left-right-line', title: 'BATNA', desc: 'Определение наилучшей альтернативы и её использование для усиления позиции' },
    { icon: 'ri-focus-2-line', title: 'Позиции и интересы', desc: 'Разделение заявляемых позиций и реальных интересов сторон' },
    { icon: 'ri-search-line', title: 'Выявление истинных потребностей', desc: 'Техника задавания вопросов для выявления скрытых потребностей клиента' },
    { icon: 'ri-shield-check-line', title: 'Работа с возражениями', desc: 'Превращение возражений в возможности для усиления предложения' },
    { icon: 'ri-mental-health-line', title: 'Управление эмоциями', desc: 'Техники саморегуляции и управления эмоциональным полем переговоров' },
    { icon: 'ri-sword-line', title: 'Ведение жёстких переговоров', desc: 'Работа с ультиматумами, давлением, агрессивными тактиками' },
    { icon: 'ri-scales-line', title: 'Торг', desc: 'Стратегия уступок, пакетные предложения, создание поля для манёвра' },
    { icon: 'ri-vip-diamond-line', title: 'Продажа ценности', desc: 'Аргументация через выгоды, ROI и долгосрочную ценность для клиента' },
    { icon: 'ri-money-dollar-circle-line', title: 'Переговоры по цене', desc: 'Защита цены без скидок, обоснование стоимости, работа с бюджетными ограничениями' },
    { icon: 'ri-store-line', title: 'Переговоры с закупщиками', desc: 'Специфика работы с профессиональными закупщиками и тендерными процедурами' },
    { icon: 'ri-organization-chart', title: 'Переговоры между отделами', desc: 'Кросс-функциональное взаимодействие, согласование интересов подразделений' },
    { icon: 'ri-global-line', title: 'Ведение переговоров онлайн', desc: 'Особенности онлайн-коммуникации, работа с камерой, управление вниманием' },
    { icon: 'ri-phone-line', title: 'Телефонные переговоры', desc: 'Структура телефонного разговора, работа с голосом, преодоление секретарского барьера' },
    { icon: 'ri-check-double-line', title: 'Финальное закрытие', desc: 'Завершение переговоров, фиксация договорённостей, предотвращение откатов' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Чему учатся участники <strong>тренинга по переговорам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            После прохождения <strong>корпоративного обучения переговорам</strong> каждый участник осваивает 15 ключевых навыков — от подготовки к встрече до финального закрытия сложных сделок.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {skills.map((skill, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mb-3 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${skill.icon} text-base text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-1.5">{skill.title}</h3>
              <p className="text-xs text-gray-600 leading-relaxed">{skill.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}